<template>
  <div>
    <OneColumnPageLayout>
      <div
        v-if="is_admin"
        class="mb-5"
      >
        {{ $t('ManageAccounts.Info') }}
      </div>

      <!-- user group -->
      <OutSideTitleCard
        :title="$t('UserGroup.UserGroups')"
        :info="$t('ManageAccounts.UserGroupInfo')"
      >
        <template #padding-zero>
          <UserGroupContent
            ref="userGroupContent"
            @selected-data="applySelectedGroups"
          />
        </template>
      </OutSideTitleCard>

      <!-- user list -->
      <OutSideTitleCard
        class="mt-5 mb-5"
        :title="$t('User.Users')"
        :info="$t('ManageAccounts.UserListInfo')"
      >
        <h5
          v-if="selectedGroups && selectedGroups.length > 0"
          style="margin-bottom: -15px;"
          class="text-secondary"
        >
          {{ $t('ManageAccounts.FilteringByGroups') }}
        </h5>

        <template #padding-zero>
          <UserListContent :selected-groups="selectedGroups" />
        </template>
      </OutSideTitleCard>
    </OneColumnPageLayout>
  </div>
</template>

<script>
  import OutSideTitleCard from '../../components/parts/card/OutSideTitleCard'
  import UserGroupContent from '../../components/content/UserGroupContent'
  import UserListContent from '../../components/content/UserListContent'
  import { mapGetters } from 'vuex'
  import OneColumnPageLayout
    from '../../components/pages/layouts/OneColumnPageLayout'

  export default {
    components: {
      OneColumnPageLayout,
      UserListContent,
      UserGroupContent,
      OutSideTitleCard
    },
    data: () => ({
      selectedGroups: null
    }),
    computed: {
      ...mapGetters(['ui', 'login']),
      is_admin () {
        return Boolean(this.login.profile.is_admin)
      }
    },
    methods: {
      applySelectedGroups (data) {
        this.selectedGroups = data
      }
    }
  }
</script>
